import React from 'react'
import { Tag } from 'antd'
import { Invite } from '../../../../context/types'

export const columns = [
	{
		title: 'Date',
		dataIndex: 'invited_on',
		key: 'invited_on',
		render: (v: string) => {
			const date = new Date(v)
			return <span>{date.toLocaleDateString()}</span>
		},
	},
	{
		title: 'Email',
		dataIndex: 'email',
		key: 'email',
	},
	{
		title: 'Is Expert',
		dataIndex: 'is_expert',
		key: 'is_expert',
		render: (v: boolean) => {
			const color = v ? 'geekblue' : 'volcano'
			return <Tag color={color}>{v ? 'Yes' : 'No'}</Tag>
		},
	},
	{
		title: 'Brand',
		dataIndex: 'brand',
		key: 'invite.channel.brand.name',
	},
	{
		title: 'Channel',
		dataIndex: 'channel',
		key: 'invite.channel.name',
	},
	{
		title: 'Invited by',
		dataIndex: 'invited_by',
		key: 'invited_by',
	},
	{
		title: 'Claimed',
		dataIndex: 'claim_count',
		key: 'claim_count',
	},
	{
		title: 'Invite code',
		dataIndex: 'invite_code',
		key: 'invite_code',
		render: (v: string, invite: Invite) => {
			const href = invite.brand_root_url + '/register?invitecode=' + btoa(v)
			return (
				<a href={href} target="blank">
					{btoa(v)}
				</a>
			)
		},
	},
]
